import React, { useRef, useState } from 'react';
import { useEffect } from 'react';
import { css } from '@emotion/core';
import Slider from 'react-slick';
import { below, breakpoints } from 'utils/breakpoint';
import PlayCircleFilledWhiteIcon from '@material-ui/icons/PlayCircleFilledWhite';
import ResponsiveUgcProxyPicture from 'client/components/ResponsiveUgcProxyPicture';

function Marquee({
    mediaData,
    handleClick,
    needHandleClick = false,
    igGame = false,
    igUrl,
    isShowPlayIcon = false
}) {
    const containerRef = useRef(null);
    const [count, setCount] = useState(1);

    useEffect(() => {
        const calculate = (dataLength, screenLength) => {
            if (dataLength === 1) {
                return 1;
            }
            if (dataLength > screenLength) {
                return screenLength;
            }
            if (screenLength >= dataLength) {
                return dataLength - 1;
            }
        };
        const toCountSlidesToShow = () => {
            const divWidth = containerRef.current.clientWidth;
            const count = Math.floor(divWidth / 200);
            const dataLength = mediaData.data.length;
            const calculateCount = calculate(dataLength, count);
            setCount(calculateCount);
        };
        toCountSlidesToShow();
        window.addEventListener('resize', toCountSlidesToShow);
        return () => {
            window.removeEventListener('resize', toCountSlidesToShow);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div css={carouselContainerStyle} ref={containerRef}>
            <Slider {...carouselSettings(count)}>
                {mediaData.data.map(({ serialNo, value }) => {
                    return (
                        <div
                            css={imgContainerStyle}
                            onClick={() => {
                                needHandleClick && handleClick(serialNo);
                            }}
                        >
                            <div
                                css={css`
                                    position: relative;
                                `}
                            >
                                <ResponsiveUgcProxyPicture
                                    key={serialNo}
                                    src={value}
                                    breakPointConfigs={{
                                        normal: proxySquareConfig,
                                        [breakpoints.xsm]: proxySquareConfig
                                    }}
                                    enableLazyLoad
                                    css={imgStyle}
                                />
                                {igGame && (
                                    <a href={igUrl}>
                                        <img
                                            src="https://assets.fevercdn.com/promotion/icon/ig_logo.svg"
                                            alt="instagramAccount"
                                            css={igIconStyle}
                                        />
                                    </a>
                                )}
                            </div>
                            {isShowPlayIcon && <PlayCircleFilledWhiteIcon css={playIconStyle} />}
                        </div>
                    );
                })}
            </Slider>
            <Slider {...secondaryCarouselSettings(count)}>
                {mediaData.secondaryData.map(({ serialNo, value }) => {
                    return (
                        <div
                            css={imgContainerStyle}
                            onClick={() => {
                                needHandleClick && handleClick(serialNo);
                            }}
                        >
                            <div
                                css={css`
                                    position: relative;
                                `}
                            >
                                <ResponsiveUgcProxyPicture
                                    key={serialNo}
                                    src={value}
                                    breakPointConfigs={{
                                        normal: proxySquareConfig,
                                        [breakpoints.xsm]: proxySquareConfig
                                    }}
                                    enableLazyLoad
                                    css={imgStyle}
                                />
                                {igGame && (
                                    <a href={igUrl}>
                                        <img
                                            src="https://assets.fevercdn.com/promotion/icon/ig_logo.svg"
                                            alt="instagramAccount"
                                            css={igIconStyle}
                                        />
                                    </a>
                                )}
                            </div>

                            {isShowPlayIcon && <PlayCircleFilledWhiteIcon css={playIconStyle} />}
                        </div>
                    );
                })}
            </Slider>
        </div>
    );
}

export default Marquee;

const proxySquareConfig = { width: 720, height: 720 };

const carouselSettings = count => {
    return {
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: count,
        slidesToScroll: 1,
        autoplay: true,
        speed: 3000,
        autoplaySpeed: 3000,
        cssEase: 'linear'
    };
};
const secondaryCarouselSettings = count => {
    return {
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: count,
        slidesToScroll: 1,
        autoplay: true,
        speed: 3000,
        autoplaySpeed: 3000,
        cssEase: 'linear',
        rtl: true
    };
};

const carouselContainerStyle = css`
    ${below('xsm')} {
        max-width: 410px;
        width: 100%;
    }
    & .slick-slider:last-child {
        margin-top: 8px;
    }
`;

const imgContainerStyle = css`
    display: flex !important;
    justify-content: center;
    align-items: center;
    border-radius: 16px;
    cursor: pointer;
    position: relative;
`;

const igIconStyle = css`
    position: absolute;
    width: 24px;
    height: 24px;
    left: 16px;
    bottom: 16px;
`;

const playIconStyle = css`
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    max-width: 53px;
    max-height: 53px;
    color: #ffffff;
    width: 100%;
    height: 100%;
`;

const imgStyle = css`
    width: 200px;
    height: 200px;
    border-radius: 16px;
    display: block;
`;
